<template>
	<vue-google-autocomplete ref="address" id="map" classname="p-inputtext p-component" :placeholder="$t('address')" v-on:keyup="keyhandler" v-on:placechanged="getAddressData" types="(cities)">
	</vue-google-autocomplete>
</template>

<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";
import $ from "jquery";

export default {
	components: {
		VueGoogleAutocomplete
	},
	props: {
		initialAddress: String
	},
	data: function() {
		return {};
	},
	methods: {
		getAddressData: function(addressData, placeResultData, id) {
			this.$emit("setCorrectAddress", placeResultData);
		},
		keyhandler: function(event) {
			if (event.key == "Enter")
				this.checkAddressValidity($("#map").val());
			else if (event.key == "Delete" || event.key == "Backspace") {
				if ($("#map").val() == "")
					this.$emit("setCorrectAddress", null);
			}
			event.preventDefault();
		},
		checkAddressValidity: function(address) {
			var geocoder = new google.maps.Geocoder();
			var self = this;
			geocoder.geocode({ address: address }, function(results, status) {
				if (
					status === google.maps.GeocoderStatus.OK &&
					results.length > 0
				) {
					$("#map").val(results[0].formatted_address);
					self.$emit("setCorrectAddress", results[0]);
				}
			});
		}
	},
	mounted() {
		if (this.initialAddress != null && this.initialAddress != "") {
			$("#map").val(this.initialAddress);
		}
	}
};
</script>

<style scoped>
/* .pac-target-input {
    z-index: 999999 !important;
} */
.p-component {
    z-index: 999999 !important;
}
</style>